<template>
  <div>
    <Navbar />

    <section class="dictionary">
      <Header :BASE_URL="API_BASE_URL" :data="data" />
      <card-dictionary />
      <div id="alphabet">
      <alphabet-section @listAll="getAllDictData" @clickLetter="doSomething($event)" />
      </div>
        <dictionary-section :filteredLetter="filteredLetter" :fetchAllWords="fetchAllWords" :data="data" :API_BASE_URL="API_BASE_URL" />
      <!-- next and prev button -->
      <div class="container">
        <div class="d-flex justify-space-between">
          <a href="#alphabet">
            <v-btn
              x-large
              icon
              color="green"
              :disabled="currentPage === 0"
              @click="prevButton"
              outlined
              title="Önceki sayfa"
              alt="Önceki sayfa"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </a>
          <a href="#alphabet">
            <v-btn
              x-large
              icon
              color="green"
              :disabled="data.length !== 16"
              @click="nextButton"
              outlined
              title="Sonraki sayfa"
              alt="Sonraki sayfa"
            >
              <v-icon>mdi-arrow-right</v-icon>
            </v-btn>
          </a>
        </div>
      </div>
      <Subscribe />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/component/navbar/Navbar"
import Header from "@/views/dictionary/Header"
import CardDictionary from "@/views/dictionary/CardDictionary"
import AlphabetSection from "@/views/dictionary/AlphabetSection"
import DictionarySection from "@/views/dictionary/DictionarySection"
// import CuriositiesSection from "@/views/dictionary/CuriositiesSection"
import Subscribe from "@/views/dictionary/Subscribe.vue"
import Footer from "@/component/footer/Footer"
import axios from "axios"

export default {
  metaInfo: {
    title: "Sigorta Sözlüğü | Alokasko.com",
    meta: [
      {
        name: "description",
        content:
          "Merak ettiğiniz tüm sigorta terimlerine A-Z'den sıralanmış listelemeli sayfasımızdan ulaşabilirsiniz. Kısa tanımlarla açıklanan terimleri öğrenin."
      }
    ]
  },
  head: {
    link: [
      { rel: 'canonical', href: 'https://www.alokasko.com/sigorta-sozlugu' }
    ]
  },
  name: "Dictionary",
  components: {
    Navbar,
    Header,
    CardDictionary,
    AlphabetSection,
    DictionarySection,
    // CuriositiesSection,
    Subscribe,
    Footer
  },
  data() {
    return {
      API_BASE_URL: "",
      data: [],
      currentPage: 0,
      filteredLetter: [],
      fetchAllWords: true
    }
  },
  methods: {
    // Bütün Sözlük Datasını Getiren Call
    fetchData() {
      axios
        .get(
           `${this.API_BASE_URL}/adm/dictionary/pages?page=${this.currentPage}&size=16`
        )
        .then(response => {
          this.data = response.data
          console.log("Sözlük verisi getirildi", this.data)
        })
    },
    nextButton() {
      if (this.data.length === 16) {
        this.currentPage++
        console.log("next button clicked", this.currentPage)
        this.fetchData()
      }
    },
    prevButton() {
      if (this.currentPage > 0) {
        this.currentPage--
        console.log("prev button clicked", this.currentPage)
        this.fetchData()
      }
    },
    // Alfabeden gelen harfi yakalayan emit fonksiyonu
    doSomething(letter) {
      this.fetchAllWords = false
      // console.log("ben emitim", this.fetchAllWords)
      axios
        .get(this.API_BASE_URL + '/adm/dictionary/start-with/' + `${letter}`)
        .then(response => {
          this.filteredLetter = response.data
          // console.log(this.filteredLetter)
        })
    },
    // Tümü butonu default seçili olacağı için Dataları gösteren kısım
    getAllDictData() {
      if (this.fetchAllWords === false) {
        this.fetchAllWords = true
        // console.log("ben bütün datayım", this.fetchAllWords)
      } else {
        console.log("İşleminizi Gerçekleştiremedim")
      }
    }
  },
  // Base Url e istek attığımız fonksiyon
  async mounted() {
    await axios
      .get("/config.json")
      .then(resp => (this.API_BASE_URL = resp.data.BASE_URL))
      .then(() => this.fetchData())
  }
}
</script>
<style lang="scss">
@import "@/css/app.scss";
</style>
